// extracted by mini-css-extract-plugin
module.exports = {"button":"common-GetPremiumButton__button--3nbBp"};